import React from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import Icon from '_src/components/Icon'

import './index.less'

const Advertise = ({ className, handlClose }) => {
  const { t } = useTranslation()

  return (
    <div className={classNames('inft-advertise', className)}>
      <div className="advertise-decorate" />
      <div className="advertise-text">{t('advertise.title')}</div>
      <div
        className="advertise-button"
        onClick={() => {
          window.open('https://t.me/iNFTspace_Global')
        }}
      >
        <Icon type="icon-telegram" className="button-icon" />
        <span className="button-text">{t('advertise.join_us')}</span>
      </div>
      <Icon type="icon-adv-close" className="icon-adv-close" onClick={handlClose} />
    </div>
  )
}

export default Advertise
